module.exports = __webpack_public_path__ + "background.webp?efe5e2e238318d4094bbf9483148d9f9";